export default function MobileToggleBtn({ toggleSidebar, isOpen, className, dark = false }) {
  return (
    <div
      onClick={toggleSidebar}
      className={`md:hidden menu ${className} flex ${isOpen && "active"}`}
    >
      <div className="flex flex-col gap-[4px] w-[30px] justify-between cursor-pointer">
        <div className={`flex  ${dark ? "bg-[#000]" : "bg-[#fff]"} h-[3px] w-[25px]`}></div>
        <div className={`flex ${dark ? "bg-[#000]" : "bg-[#fff]"} h-[3px] w-[25px]`}></div>
        <div className={`flex ${dark ? "bg-[#000]" : "bg-[#fff]"} h-[3px] w-[25px]`}></div>
      </div>
    </div>
  );
}
